import { render, staticRenderFns } from "./PlanoSafraDropdown.vue?vue&type=template&id=01339218&scoped=true&"
import script from "./PlanoSafraDropdown.vue?vue&type=script&lang=js&"
export * from "./PlanoSafraDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PlanoSafraDropdown.vue?vue&type=style&index=0&id=01339218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01339218",
  null
  
)

export default component.exports